import { Star, Gift, Users, TrendingUp } from "lucide-react";

export default function LoyaltySection({ loyalty }) {
  if (!loyalty || !loyalty.enabled) return null;

  var percentage = loyalty.total_referrals > 0
    ? Math.round((loyalty.converted_referrals / loyalty.total_referrals) * 100)
    : 0;

  return (
    <div className="bg-gradient-to-br from-[#0A2F3D] to-[#164B60] rounded-2xl shadow-sm p-4 sm:p-6 text-white" data-testid="profile-loyalty-section">
      <h2 className="text-base font-bold mb-4 flex items-center gap-2">
        <Star className="w-5 h-5 text-[#F26A4B]" />Programa Fidelidade
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="bg-white/10 rounded-xl p-3 text-center">
          <Gift className="w-5 h-5 mx-auto mb-1 text-[#F26A4B]" />
          <p className="text-2xl font-bold" data-testid="loyalty-points">{loyalty.points}</p>
          <p className="text-xs text-white/60">Pontos</p>
        </div>
        <div className="bg-white/10 rounded-xl p-3 text-center">
          <Users className="w-5 h-5 mx-auto mb-1 text-[#3B82F6]" />
          <p className="text-2xl font-bold" data-testid="loyalty-total-referrals">{loyalty.total_referrals}</p>
          <p className="text-xs text-white/60">Indicacoes</p>
        </div>
        <div className="bg-white/10 rounded-xl p-3 text-center">
          <TrendingUp className="w-5 h-5 mx-auto mb-1 text-emerald-400" />
          <p className="text-2xl font-bold" data-testid="loyalty-converted">{loyalty.converted_referrals}</p>
          <p className="text-xs text-white/60">Convertidas</p>
        </div>
        <div className="bg-white/10 rounded-xl p-3 text-center">
          <Star className="w-5 h-5 mx-auto mb-1 text-amber-400" />
          <p className="text-2xl font-bold">{percentage}%</p>
          <p className="text-xs text-white/60">Conversao</p>
        </div>
      </div>
      <p className="text-xs text-white/40 mt-3 text-center">Cada indicacao convertida vale {loyalty.points_per_referral} pontos</p>
    </div>
  );
}
